export enum gefaehrdungsbeurteilungArtenModel {
  SINGULAR = "GBU-Art",
  PLURAL = "GBU-Arten",
  ROUTE = "/gefaehrdungsbeurteilungArt",
  ICON = "mdi-cards-outline",
  ITEM_KEY = "gefaehrdungsbeurteilungArt",
  ITEM_KEY_UPDATE = "gefaehrdungsbeurteilungArten",
}
